module.exports = __webpack_public_path__ + "static/media/calendar.6e85ff86.svg";